// extracted by mini-css-extract-plugin
module.exports = {"container":"chooseLogo_container__3s6Zi","box":"chooseLogo_box__1mM2s","logo":"chooseLogo_logo__2Kx9v","text":"chooseLogo_text__20IhI","selected":"chooseLogo_selected__3920G"};